/** Full disclosure spoken at start of calls; also used in LLM transcription prompt and post-processing. */
export const CALL_RECORDING_DISCLOSURE_TEXT = `To ensure the quality of our services, all calls are recorded for training and note taking purposes.`;

/** Shorter whisper variant of the call recording disclaimer. */
export const CALL_RECORDING_WHISPER_TEXT = `All calls are recorded for training and note taking purposes.`;

/**
 * Exact token the LLM must return when no human speech is present (see transcribe prompt).
 */
export const LLM_NO_SPEECH_DETECTED_SENTINEL = 'NO_SPEECH_DETECTED';

/**
 * Canonical transcription text persisted and shown in the care portal when the LLM reports no usable human speech.
 */
export const NO_SPEECH_DETECTED_TRANSCRIPT_MESSAGE = 'No speech detected';
